import React from 'react'
import TypeComp from '../../components/upload/Type'

const Type = () => {
  return (
   <TypeComp/>
  )
}

export default Type